import { Component, Input, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { WindDirectionIconsMap } from 'src/app/models/app-constants';
import { Observe } from 'src/app/shared/custom-decorators/Observe';
import { NoWindDataText } from 'src/app/models/app-constants';

@Component({
	selector: 'app-wind-forecast',
	templateUrl: './wind-forecast.component.html',
	styleUrls: ['./wind-forecast.component.scss']
})
export class WindForecastComponent implements OnInit, OnDestroy {
	@Input() windDir : string | undefined = "";
	@Input() windSpeedKmh : number | undefined;
	@Observe("windDir") windDir$ : Observable<string>;

	public windDirIcon : string = "";
	private windDirSub : Subscription;
	public windData: boolean = false;
	public noWindData: string = NoWindDataText;

	ngOnInit(): void {
		if (this.windDir != null && this.windSpeedKmh != null){
			this.windData = true
		}

		this.windDirSub = this.windDir$.subscribe({
			next : (value : string) => {
				this.onWindDirChange();
			},
			error : (ex : Error) => {

			},
			complete : () => {

			}
		});
	}

	ngOnDestroy(): void {
		this.windDirSub && this.windDirSub?.unsubscribe(); //test
	}


	private onWindDirChange = () => {
		this.windDirIcon = WindDirectionIconsMap.get(this.windDir?.toString()?.toUpperCase()!) ?? "" ;
		// switch(this.windDir?.toString()?.toUpperCase())
		// {
		// 	case "EAST":
		// 	case "E" :
		// 		this.windDirIcon = "assets/images/SiteDetails/WindDirection/East.svg";
		// 		break;

		// 	case "WEST":
		// 	case "W":
		// 		this.windDirIcon = "assets/images/SiteDetails/WindDirection/West.svg";
		// 		break;

		// 	case "SOUTH":
		// 	case "S":
		// 		this.windDirIcon = "assets/images/SiteDetails/WindDirection/South.svg";
		// 		break;

		// 	case "NORTH":
		// 	case "N" :
		// 		this.windDirIcon = "assets/images/SiteDetails/WindDirection/North.svg";
		// 		break;
			
		// 	case "NW" :
		// 	case "NNW" :			
		// 	case "WNW":
		// 		this.windDirIcon = "assets/images/SiteDetails/WindDirection/North-West.svg";
		// 		break;
		// 	case "NE" :
		// 	case "NNE" : 
		// 	case "ENE" :
		// 		this.windDirIcon = "assets/images/SiteDetails/WindDirection/North-East.svg";
		// 		break;
			
		// 	case "SW" :
		// 	case "SSW" :			
		// 	case "WSW":
		// 		this.windDirIcon = "assets/images/SiteDetails/WindDirection/South-West.svg";
		// 		break;

		// 	case "SE" :
		// 	case "SSE" : 
		// 	case "ESE" :
		// 		this.windDirIcon = "assets/images/SiteDetails/WindDirection/South-East.svg";
		// 		break;

		// 	default : 
		// 		this.windDirIcon = "";
		// 		break;
		// }
	}

	getWindDirection() : string {
		if(this.windDir && null != this.windSpeedKmh && 
			/^\d+/i.test(this.windSpeedKmh.toString()))
		{
			return `${this.windDir} ${this.windSpeedKmh}km/h`;
		}

		return "";
	}


}
